import { FC } from 'react'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useRequestsStore } from '../../store/storeRequests'

type Props = {
    open: boolean
    handleClose: VoidFunction
    ids: number[]
    hardDelete: boolean
}

export const ReplyDeleteDialog: FC<Props> = ({ open, handleClose, ids, hardDelete }) => {
    const { removeReply, isLoadingRemoveRequest } = useRequestsStore((state) => state)

    const handleClickDelete = async () => {
        await removeReply(ids, true)

        handleClose()
    }

    const handleClickHardDelete = async () => {
        await removeReply(ids, false)

        handleClose()
    }

    return (
        !hardDelete ? <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickDelete}
            handleClose={handleClose}
            title="Убрать сообщение из контекста?"
            submitButtonText="Убрать"
            isDisabled={isLoadingRemoveRequest}>
            Вы действительно хотите убрать из контекста выбранное сообщение?
            Удалённые сообщения и их вложения не будут учитываться в дальнейшем диалоге, но вы всегда сможете их восстановить.
            Удалённые сообщения также не будут отображаться если "Поделиться" диалогом.
        </ConfirmDialogWrapper> : <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickHardDelete}
            handleClose={handleClose}
            title="Удалить сообщение?"
            submitButtonText="Удалить"
            isDisabled={isLoadingRemoveRequest}>
            Вы действительно хотите удалить выбранное сообщение?
            Сообщение будет полностью удалено.
        </ConfirmDialogWrapper>
    )
}
